/* eslint-disable @typescript-eslint/no-explicit-any */
import { filter } from "rxjs/operators"

export const truthy = <T>() => filter<T>(id => !!id)
